import { DATE_FORMATS } from 'constants/date';

import dayjs from 'dayjs';

export type FormatedDateReturnType = {
    targetMonth: string;
    targetDay: string;
    targetYear: string;
};

export const getFormatedDate = (expirationDate: string): FormatedDateReturnType => {
    return {
        targetMonth: dayjs(expirationDate).format(DATE_FORMATS.MMM),
        targetDay: dayjs(expirationDate).format(DATE_FORMATS.DD),
        targetYear: dayjs(expirationDate).format(DATE_FORMATS.YYYY),
    };
};
